const { getCustomerFields } = require("./apiFunctions");

async function getCustomFields(parentID, type) {
  try {
    let response = await getCustomerFields({ parentID });
    if (response.status === 200) {
      const fields = response.data.data.fields;
      const predefinedFields = response.data?.data?.predefinedFields || [];
      const mergedArray = [];
      const keysSet = new Set();
      const addToMergedArray = (obj) => {
        if (!keysSet.has(obj.key)) {
          mergedArray.push(obj);
          keysSet.add(obj.key);
        }
      };
      fields.forEach(addToMergedArray);
      predefinedFields.forEach(addToMergedArray);

      const object = {
        customFields: {},
      };
      const touchedFields = {};
      fields.forEach((field) => {
        if (field.fieldType == "default") {
          field.controlType == "multi_select" ||
          field.controlType === "multi_text"
            ? (object[field.key] = [])
            : field.controlType === "boolean"
            ? (object[field.key] = false)
            : (object[field.key] = "");
          touchedFields[field.key] = false;
        } else {
          field.controlType == "multi_select" ||
          field.controlType === "multi_text"
            ? (object["customFields"][field.key] = [])
            : field.controlType === "boolean"
            ? (object["customFields"][field.key] = false)
            : (object["customFields"][field.key] = "");
          touchedFields[field.key] = false;
        }
      });
      if (type == "edit") {
        return [fields, touchedFields, mergedArray];
      }
      return [fields, object, touchedFields, mergedArray];
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
}

function dynamicRules(fields) {
  let rules = {
    customFields: {},
  };
  for (let key in fields) {
    if (fields[key].fieldType == "default") {
      rules[fields[key].key] = {
        required: fields[key].mandatory,
      };
    } else {
      rules["customFields"][fields[key].key] = {
        required: fields[key].mandatory,
      };
    }
  }
  return rules;
}

function columnWidth(data) {
  const screenWidth = window.innerWidth;

  // Perform action based on screen size
  if (screenWidth < 900) {
    return 12;
  } else if (
    data == "text" ||
    data == "email" ||
    data == "single_select" ||
    data == "multi_select" ||
    data == "number" ||
    data == "boolean" ||
    data == "multi_text" ||
    data == "date"
  ) {
    return 4;
  } else if (data == "upload_file") {
    return 9;
  } else {
    return 12;
  }
}

function showError(field, dirtyStatus, context) {
  if (dirtyStatus) {
    if (!validateField(field, context)) {
      return true;
    }
  }
  return false;
}

function validateField(
  field,
  { newObject, validations, valText, savedOpeningsCount }
) {
  const value =
    field.fieldType === "default"
      ? newObject[field.key]
      : newObject.customFields[field.key];
  const rules =
    field.fieldType === "default"
      ? validations[field.key]
      : validations.customFields[field.key];

  // Check if the field is required
  if (rules && rules.required) {
    if (field.key == "title") {
      if (value.length == 0) {
        valText[field.key] = "Required";
        return false;
      }
      const titleRegex = /^[a-zA-Z]/;
      if (!titleRegex.test(value)) {
        valText[field.key] = "Invalid title";
        return false;
      }
      if (field.limit && value && value.length > parseInt(field.limit)) {
        valText[field.key] = "Max Char Exceeded";
        return false;
      }
    } else if (field.key == "openingsCount") {
      if (!value) {
        valText[field.key] = "Required";
        return false;
      }
      if (savedOpeningsCount != null && savedOpeningsCount > value) {
        valText[field.key] = "Should be greater than previous";
        return false;
      }
      if (field.limit && value && value.length > parseInt(field.limit)) {
        valText[field.key] = "Max Char Exceeded";
        return false;
      }
    } else if (field.controlType === "multi_select") {
      if (!Array.isArray(value) || (value && value.length === 0)) {
        valText[field.key] = "Required";
        return false;
      }
    } else if (field.controlType === "email") {
      const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
      if (value.length == 0) {
        valText[field.key] = "Required";
        return false;
      }
      if (value && value.length > 0 && !emailRegex.test(value)) {
        valText[field.key] = "Invalid email";
        return false;
      }
      if (field.limit && value && value.length > parseInt(field.limit)) {
        valText[field.key] = "Max Char Exceeded";
        return false;
      }
    } else if (field.controlType === "single_select") {
      if (Array.isArray(field.values) && field.values.length > 0) {
        const hasDefault = field.values.some((opt) => opt.isDefault);
        if (!hasDefault && !value) {
          valText[field.key] = "Required";
          return false;
        }
      } else if (!value) {
        valText[field.key] = "Required";
        return false;
      }
    } else if (field.controlType === "upload_file") {
      if (value instanceof File) {
        if (!value || value.name.length === 0) {
          valText[field.key] = "Required";
          return false;
        }
      } else {
        if (!value || value.length === 0 || Object.keys(value).length === 0) {
          valText[field.key] = "Required";
          return false;
        }
      }
    } else if (field.controlType == "multi_text") {
      if (!value || value.length == 0) {
        valText[field.key] = "Required";
        return false;
      }
      // multi_text is a list: limit caps each entry's length, not the entry count
      if (
        field.limit &&
        (Array.isArray(value)
          ? value.some((entry) => String(entry).length > parseInt(field.limit))
          : value.length > parseInt(field.limit))
      ) {
        valText[field.key] = "Max Char Exceeded";
        return false;
      }
    } else if (field.controlType == "rich_text_box") {
      if (!value || value.length === 0) {
        valText[field.key] = "Required";
        return false;
      } else {
        let plainText = value && value.replace(/<[^>]+>/g, ""); // Remove HTML tags
        plainText = plainText && plainText.replace(/&nbsp;/g, " "); // Replace &nbsp; with regular spaces
        plainText = plainText && plainText.trim(); // Trim leading and trailing whitespace
        if (plainText && !plainText.length) {
          valText[field.key] = "Required";
          return false;
        } else if (
          field.limit &&
          plainText &&
          plainText.length > parseInt(field.limit)
        ) {
          valText[field.key] = "Max Char Exceeded";
          return false;
        }
      }
    } else {
      // Check if the value is empty or exceeds the character limit
      if (!value) {
        valText[field.key] = "Required";
        return false;
      } else if (field.limit && value.length > parseInt(field.limit)) {
        valText[field.key] = "Max Char Exceeded";
        return false;
      } else if (field.key == "phoneNumber" || field.key == "altPhoneNumber") {
        const phoneRegex = /^\d{7,10}$/;
        if (value.length == 0) {
          valText[field.key] = "Required";
          return false;
        }
        if (value && value.length > 0 && !phoneRegex.test(value)) {
          valText[field.key] = "Enter Valid Phone Number";
          return false;
        }
        if (field.limit && value && value.length > parseInt(field.limit)) {
          valText[field.key] = "Max Char Exceeded";
          return false;
        }
      } else if (field.key === "openingsCount" && value == 0) {
        valText[field.key] = "Openings Count should be more than 0";
        return false;
      } else if (field.key == "workingTime") {
        if (value > 24) {
          valText[field.key] = "Working hours should not be greater than 24";
          return false;
        }
      } else if (field.key == "experince") {
        if (value > 99) {
          valText[field.key] = "Experience should not be greater than 99";
          return false;
        }
      }
    }
  } else {
    if (field.controlType === "email" && value && value.length > 0) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
      if (!emailRegex.test(value)) {
        valText[field.key] = "Invalid email";
        return false;
      }
      if (field.limit && value && value.length > parseInt(field.limit)) {
        valText[field.key] = "Max Char Exceeded";
        return false;
      }
    } else if (value && field.controlType == "rich_text_box") {
      let plainText = value.replace(/<[^>]+>/g, ""); // Remove HTML tags
      plainText = plainText.replace(/&nbsp;/g, " "); // Replace &nbsp; with regular spaces
      plainText = plainText.trim(); // Trim leading and trailing whitespace
      if (!plainText.length) {
        valText[field.key] = "Required";
        return false;
      } else if (field.limit && plainText.length > parseInt(field.limit)) {
        valText[field.key] = "Max Char Exceeded";
        return false;
      }
    } else if (field.key == "workingTime") {
      if (value > 24) {
        valText[field.key] = "Working hours should not be greater than 24";
        return false;
      }
    } else if (field.key == "experince") {
      if (value > 99) {
        valText[field.key] = "Experience should not be greater than 99";
        return false;
      }
    } else if (field.controlType === "multi_text") {
      if (
        field.limit &&
        value &&
        (Array.isArray(value)
          ? value.some((entry) => String(entry).length > parseInt(field.limit))
          : value.length > parseInt(field.limit))
      ) {
        valText[field.key] = "Max Char Exceeded";
        return false;
      }
    } else if (field.limit && value && value.length > parseInt(field.limit)) {
      if (["otherNoticePeriod", "otherSource"].includes(field.key)) {
        let mainKey = field.key === "otherSource" ? "source" : "noticePeriod";
        let valuesarr =
          field.fieldType === "default" ? newObject : newObject.customFields;
        if (valuesarr[mainKey] !== "other") {
          return true;
        }
      }
      valText[field.key] = "Max Char Exceeded";
      return false;
    }
  }
  return true;
}

function checkFieldKeys(field, viewObject) {
  let fieldKey;
  if (field.fieldType == "default") {
    if (
      viewObject[field.key] === "" ||
      viewObject[field.key] === undefined ||
      viewObject[field.key] === null ||
      viewObject[field.key].length === 0
    ) {
      fieldKey = true;
    } else {
      fieldKey = false;
    }
  } else {
    if (
      Object.keys(viewObject).length != 0 &&
      (viewObject.customFields[field.key] === "" ||
        viewObject.customFields[field.key] === undefined ||
        viewObject.customFields[field.key] === null ||
        viewObject.customFields[field.key].length === 0)
    ) {
      fieldKey = true;
    } else {
      fieldKey = false;
    }
  }
  return fieldKey;
}
function isHtmlContent(field, viewObject) {
  const customField =
    field.fieldType == "default"
      ? viewObject[field.key]
      : viewObject.customFields[field.key];
  if (
    (field.controlType == "rich_text_box" &&
      typeof viewObject[field.key] === "string" &&
      viewObject[field.key] !== "") ||
    (field.controlType == "rich_text_box" &&
      typeof customField === "string" &&
      customField !== "")
  ) {
    return true;
  } else {
    return false;
  }
}
function checkValuesOfKey(field, viewObject) {
  let fieldValue;
  if (field.fieldType === "default") {
    if (
      field.controlType == "multi_select" &&
      Array.isArray(viewObject[field.key])
    ) {
      let usernameArray = viewObject[field.key].map(
        (obj) => obj.username || obj.name
      );
      fieldValue = usernameArray.join(", ");
    } else if (
      field.controlType == "single_select" &&
      typeof viewObject[field.key] === "string" &&
      viewObject[field.key] !== ""
    ) {
      let val;
      if (viewObject[field.key] == "vendor") {
        fieldValue = "Vendor";
      } else {
        field.values.forEach((value) => {
          if (value.key == viewObject[field.key]) {
            val = value.label;
          }
        });
        fieldValue = val;
      }
    } else if (
      field.controlType == "upload_file" &&
      typeof viewObject[field.key] === "string" &&
      viewObject[field.key] !== ""
    ) {
      let lastIndex = viewObject[field.key].lastIndexOf("/");
      fieldValue = viewObject[field.key].substring(lastIndex + 1);
    } else if (
      field.controlType == "multi_text" &&
      Array.isArray(viewObject[field.key])
    ) {
      fieldValue = viewObject[field.key].join(", ");
    } else if (field.controlType == "boolean") {
      fieldValue =
        viewObject[field.key] == "" ||
        viewObject[field.key] == null ||
        viewObject[field.key] == false
          ? "No"
          : "Yes";
    } else {
      fieldValue = viewObject[field.key];
    }
  } else {
    const customField = viewObject.customFields[field.key];
    if (field.controlType == "multi_select" && Array.isArray(customField)) {
      if (field.key == "buHead" || field.key == "hiringManager") {
        let usernameArray = customField.map((obj) => obj.username);
        fieldValue = usernameArray.join(", ");
      } else {
        const fieldValues = [];
        field.values.forEach((val) => {
          customField.forEach((key) => {
            if (val.key === key) {
              fieldValues.push(val.label);
            }
          });
        });
        fieldValue = fieldValues.join(", ");
      }
    } else if (
      field.controlType == "single_select" &&
      typeof customField === "string" &&
      customField !== ""
    ) {
      let val;
      field.values.forEach((value) => {
        if (value.key === customField) {
          val = value.label;
        }
      });
      fieldValue = val;
    } else if (
      field.controlType == "upload_file" &&
      typeof customField === "string" &&
      customField !== ""
    ) {
      let lastIndex = customField.lastIndexOf("/");
      fieldValue = customField.substring(lastIndex + 1);
    } else if (
      field.controlType === "multi_text" &&
      Array.isArray(customField)
    ) {
      fieldValue = customField.join(", ");
    } else if (field.controlType == "boolean") {
      fieldValue =
        customField == "" || customField == null || customField == false
          ? "No"
          : "Yes";
    } else {
      fieldValue = customField;
    }
  }

  return fieldValue;
}

function getSource(type) {
  if (type == "naukri") {
    return require("../assets/img/talentpool/naukri.svg");
  } else if (type == "linkedin") {
    return require("../assets/img/talentpool/linkdin.svg");
  } else if (type == "monster") {
    return require("../assets/img/talentpool/monster.svg");
  } else if (type == "indeed") {
    return require("../assets/img/talentpool/indeed.svg");
  } else if (type == "indeed") {
    return require("../assets/img/talentpool/indeed.svg");
  } else if (type == "vendor") {
    return require("../assets/img/talentpool/vendor.svg");
  } else if (type == "seek") {
    return require("../assets/img/talentpool/seek.svg");
  } else {
    return require("../assets/img/talentpool/default.svg");
  }
}

function fileType(file) {
  return require(`../assets/img/foldericons/${file}.svg`);
}

// Label for a form field shown outside its form (filters, table columns).
// Conditional child fields (e.g. "Others (In days)" under Notice Period) are
// prefixed with their parent's label so they make sense on their own.
function fieldDisplayLabel(field, fields) {
  const label = field.label || field.key;
  if (!field.parentKey) return label;
  const parent = (fields || []).find((f) => f.key === field.parentKey);
  return parent && parent.label ? `${parent.label}: ${label}` : label;
}

module.exports = {
  getCustomFields,
  dynamicRules,
  columnWidth,
  showError,
  validateField,
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
  getSource,
  fileType,
  fieldDisplayLabel,
};
